document.addEventListener('DOMContentLoaded', function () {
  const mz = window.mz;
  if (!mz) {
    return;
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function getLazySectionId() {
    if (mz.collectionSectionId) {
      return mz.collectionSectionId;
    }
    try {
      const stored = sessionStorage.getItem('mzCollectionSectionId');
      if (stored) {
        return stored;
      }
    } catch (e) {
      // ignore
    }
    return mz.sectionId;
  }
  function lazyLoadItem(el, item, callback) {
    const sectionId = getLazySectionId();
    if (!sectionId) {
      return;
    }
    fetch(
      `/collections/all?section_id=${sectionId}&sort_by=mezereon:${item.handle}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const mzCardProduct = html.querySelector('.mz-card-product');
        if (!mzCardProduct) {
          return;
        }
        callback(mzCardProduct.innerHTML);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  function afterUpdate() {
    // placeholder
  }
  function reloadSection(e) {
    if (e.detail.sectionId !== mz.sectionId) {
      return;
    }
    mz.initializeVueApp();
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate);
    mz.app.$bus.on('lazy-load-item', lazyLoadItem);
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) =>
        reloadSection(e),
      );
    }
  }
});
